"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HERO_BANNER_MOBILE_HEIGHT = exports.HERO_BANNER_MIN_HEIGHT = exports.HERO_BANNER_DEFAULT_WIDTH = exports.HERO_BANNER_DEFAULT_TIMER = exports.HERO_BANNER_DEFAULT_INDEX = exports.HERO_BANNER_DEFAULT_HEIGHT = exports.DEFAULT_TIMEZONE = void 0;
var HERO_BANNER_DEFAULT_WIDTH = '100%';
exports.HERO_BANNER_DEFAULT_WIDTH = HERO_BANNER_DEFAULT_WIDTH;
var HERO_BANNER_DEFAULT_HEIGHT = '280px';
exports.HERO_BANNER_DEFAULT_HEIGHT = HERO_BANNER_DEFAULT_HEIGHT;
var HERO_BANNER_MIN_HEIGHT = '100px';
exports.HERO_BANNER_MIN_HEIGHT = HERO_BANNER_MIN_HEIGHT;
var HERO_BANNER_MOBILE_HEIGHT = '100px';
exports.HERO_BANNER_MOBILE_HEIGHT = HERO_BANNER_MOBILE_HEIGHT;
var HERO_BANNER_DEFAULT_TIMER = '3000';
exports.HERO_BANNER_DEFAULT_TIMER = HERO_BANNER_DEFAULT_TIMER;
var HERO_BANNER_DEFAULT_INDEX = 0;
exports.HERO_BANNER_DEFAULT_INDEX = HERO_BANNER_DEFAULT_INDEX;
var DEFAULT_TIMEZONE = 'Asia/Kuala_Lumpur';
exports.DEFAULT_TIMEZONE = DEFAULT_TIMEZONE;